import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AppTitleStrategy extends TitleStrategy {
  private static readonly APP_NAME = 'Integrity Elementz';

  private readonly title = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const pageTitle = this.buildTitle(snapshot);

    this.title.setTitle(
      pageTitle ? `${pageTitle} | ${AppTitleStrategy.APP_NAME}` : AppTitleStrategy.APP_NAME
    );
  }
}
